// Without this, the bundler runtime keeps the build-time `/packs/` publicPath
// and fetches lazy chunks from the request origin even when Rails served the
// initial assets from the CDN. Must run before any chunked module evaluates.
if (typeof window !== "undefined" && window.__CIRCLE_ASSET_HOST__) {
  // eslint-disable-next-line no-undef -- free variable injected by the bundler runtime
  __webpack_public_path__ = `${window.__CIRCLE_ASSET_HOST__}/packs/`;
}
